import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'
import smoothScroll from './smooth-scroll.min'
import 'bootstrap/js/scrollspy'

new Vue({
    el: '#app',
    data: {
        scrollPos: 0,
        botellasTransition: false,
        botellas: [
            {
                status: 'active',
                num: null,
                class: ''
            },
            {
                status: 'right',
                num: 1,
                class: ''
            },
            {
                status: 'right',
                num: 2,
                class: ''
            },
            {
                status: 'right',
                num: 3,
                class: ''
            },
            {
                status: 'right',
                num: 4,
                class: ''
            },
            {
                status: 'right',
                num: 5,
                class: ''
            },
            {
                status: 'right',
                num: 6,
                class: ''
            },
            {
                status: 'right',
                num: 7,
                class: ''
            },
            {
                status: 'right',
                num: 8,
                class: ''
            },
            {
                status: 'right',
                num: 9,
                class: ''
            },
            {
                status: 'right',
                num: 10,
                class: ''
            },
            {
                status: 'right',
                num: 11,
                class: ''
            },
            {
                status: 'right',
                num: 12,
                class: ''
            },
            {
                status: 'right',
                num: 13,
                class: ''
            },
            {
                status: 'right',
                num: 14,
                class: ''
            },
            {
                status: 'right',
                num: 15,
                class: ''
            },
            {
                status: 'left',
                num: 15,
                class: ''
            },
            {
                status: 'left',
                num: 14,
                class: ''
            },
            {
                status: 'left',
                num: 13,
                class: ''
            },
            {
                status: 'left',
                num: 12,
                class: ''
            },
            {
                status: 'left',
                num: 11,
                class: ''
            },
            {
                status: 'left',
                num: 10,
                class: ''
            },
            {
                status: 'left',
                num: 9,
                class: ''
            },
            {
                status: 'left',
                num: 8,
                class: ''
            },
            {
                status: 'left',
                num: 7,
                class: ''
            },
            {
                status: 'left',
                num: 6,
                class: ''
            },
            {
                status: 'left',
                num: 5,
                class: ''
            },
            {
                status: 'left',
                num: 4,
                class: ''
            },
            {
                status: 'left',
                num: 3,
                class: ''
            },
            {
                status: 'left',
                num: 2,
                class: ''
            },
            {
                status: 'left',
                num: 1,
                class: ''
            },
        ],
        vinos: [
            {
                active: false,
                rActive: true,
            },
            {
                active: false,
                rActive: false,
            },
            {
                active: false,
                rActive: false,
            },
            {
                active: false,
                rActive: false,
            }
        ],
        vinosActive: false,
        contactActive: false,
        windowWidth: 1200,
        interval: null,
        created: false,
        year: new Date().getFullYear(),
        form: {
            name: {
                value: '',
                error: false,
                message: ''
            },
            email: {
                value: '',
                error: false,
                message: ''
            },
            subject: {
                value: '',
                error: false,
                message: ''
            },
            message: {
                value: '',
                error: false,
                message: ''
            }
        },
        formLoad: false,
        collage: {
            _1: true,
            _2: false
        },
        autoPlayCarousel: true
    },
    created: function() {
        this.created = true
        window.addEventListener('resize', this.resize)
        this.windowWidth = window.innerWidth
        // this.carousel();
        this.resize()
        if (this.windowWidth <= 768) {
            this.contactActive = true
        }

        $(document).ready(function() {
            $(".menu").on("activate.bs.scrollspy", function(e){
                this.scrollPos = parseInt($(".nav li.active").attr('num'));
            }.bind(this))
            $("body").scrollspy({target: ".menu"});
            smoothScroll.init({
                easing: 'easeInOutQuart',
                speed: 1000,
            }); //SmootScroll
        }.bind(this))

        setInterval(() => {
            this.collages();
        }, 5000)
        this.autoPlay();
        this.keyMoveCarousel();
    },
    methods: {
        carousel(object) {
            if (object.isManual) {
                this.stopAutoPlay({
                    replay: 5000,
                });
            }
            var active = null;
            var activeRight = null;
            var activeLeft = null;
            
            this.botellas.forEach(function(item, i) {
                if (item.status === 'active') {
                    if (object.next) {
                        active = ((i + 1) === 31) ? 0 : (i + 1)
                        activeRight = ((i + 1) === 31) ? 0 : (i + 1)
                        activeLeft = ((i + 1) === 31) ? 0 : (i + 1)
                    }else if (object.prev) {
                        active = ((i - 1) === -1) ? 30 : (i - 1)
                        activeRight = ((i - 1) === -1) ? 30 : (i - 1)
                        activeLeft = ((i - 1) === -1) ? 30 : (i - 1)
                    }
                }
            }.bind(this));

            for (var i = 1; i < 16; i++) {
                activeRight++
                if(activeRight === 31) activeRight = 0
                this.botellas[activeRight].status = 'right'
                this.botellas[activeRight].num = i
            }
            for (var i = 1; i < 16; i++) {
                activeLeft--
                if(activeLeft === -1) activeLeft = 30
                this.botellas[activeLeft].status = 'left'
                this.botellas[activeLeft].num = i
            }
            this.botellas[active].status = 'active'
            this.botellas[active].num = null
        },
        prevVinos() {
            var itemActive = null,
                itemActivar = null;
            this.vinos.forEach((item, i) => {
                if (item.active) {
                    itemActivar = ((i - 1) === -1) ? (this.vinos.length - 1) : (i - 1);
                    itemActive = i;
                }
            })
            this.vinos[itemActive].active = false
            this.vinos[itemActivar].active = true
        },
        nextVinos() {
            var itemActive = null,
                itemActivar = null;
            this.vinos.forEach((item, i) => {
                if (item.active) {
                    itemActivar = ((i + 1) === (this.vinos.length)) ? 0 : (i + 1);
                    itemActive = i;
                }
            })
            this.vinos[itemActive].active = false
            this.vinos[itemActivar].active = true
        },
        vinosInf(i) {
            this.vinos[i].active = true
            this.vinosActive = true
        },
        cerrarVinosInf() {
            this.vinos.forEach((item) => {
                item.active = false
            })
            this.vinosActive = false
        },
        resize(e) {
            if(e) this.windowWidth = e.target.innerWidth
            if (this.windowWidth <= 600) {
                this.vinos.forEach((item, i) => {
                    if (i === 0) {
                        item.rActive = true
                    }else {
                        item.rActive = false                        
                    }
                })

            }else {
                this.vinos.forEach((item, i) => {
                    item.rActive = true
                })
            }
        },
        rVinosNext() {
            var active = null;
            this.vinos.forEach((item, i) => {
                if (item.rActive) {
                    active = i
                }
            })
            var activar = ((active + 1) === 4) ? 0 : (active + 1);
            this.vinos[active].rActive = false
            this.vinos[activar].rActive = true
        },
        rVinosPrev() {
            var active = null;
            this.vinos.forEach((item, i) => {
                if (item.rActive) {
                    active = i
                }
            })
            var activar = ((active - 1) === -1) ? 3 : (active - 1);
            this.vinos[active].rActive = false
            this.vinos[activar].rActive = true
        },
        to(object) {
            if (object.prev) {
                var active = $('.menu ul li').filter('[num="'+object.num+'"]').prev()
                if (!active.hasClass('navegacion')) {
                    var body = document.querySelector($('a', active).attr('href'));
                    smoothScroll.animateScroll(body);
                }
            }else if (object.next) {
                var active = $('.menu ul li').filter('[num="'+object.num+'"]').next()
                if (!active.hasClass('navegacion')) {
                    var body = document.querySelector($('a', active).attr('href'));
                    smoothScroll.animateScroll(body);
                }
            }

            // active.remove()
            // console.log(active)
            // if (object.prev) {
                
            // }
            // console.log(object)
            // .menu ul li a
        },
        sendEmail() {
            for (var key in this.form) {
                if(key = 'name') {
                    if (this.form[key].value === '') {
                        this.form[key].error = true
                        this.form[key].message = 'El campo \'Nombre\' es requerido'
                    }else {
                        this.form[key].error = false
                        this.form[key].message = ''
                    }
                }
                if(key = 'email') {
                    var formato = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;                    
                    if (this.form[key].value === '') {
                        this.form[key].error = true
                        this.form[key].message = 'El campo \'Correo Electronico\' es requerido'
                    }else if (!formato.test(this.form[key].value)) {
                        this.form[key].error = true
                        this.form[key].message = 'Debes ingresar un correo electronico real, ejemp. ejeplo@ialca.com.ve'
                    }else {
                        this.form[key].error = false
                        this.form[key].message = ''
                    }
                }
                if(key = 'subject') {
                    if (this.form[key].value === '') {
                        this.form[key].error = true
                        this.form[key].message = 'El campo \'Asunto del mensaje\' es requerido'
                    }else {
                        this.form[key].error = false
                        this.form[key].message = ''
                    }
                }
                if(key = 'message') {
                    if (this.form[key].value === '') {
                        this.form[key].error = true
                        this.form[key].message = 'El campo \'Mensaje\' es requerido'
                    }else {
                        this.form[key].error = false
                        this.form[key].message = ''
                    }
                }
            }
            // console.log(this.form.name, this.form.email, this.form.subject, this.form.message)
            if (!this.form.name.error && !this.form.email.error && !this.form.subject.error && !this.form.message.error) {
                this.formLoad = true
                axios.post('/send.php', $('#form').serialize())
                .then((response) => {
                    setTimeout(() => {
                        for (var key in this.form) {
                            this.form[key].value = ''
                        }
                        this.formLoad = false
                    }, 2000)
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        },
        collages() {
            this.collage._1 = !this.collage._1
            this.collage._2 = !this.collage._2
        },
        autoPlay() {
            setInterval(() => {
                if (this.autoPlayCarousel) {
                    this.carousel({next: true, isManual: false});
                }
            }, 7000);
        },
        stopAutoPlay(options) {
            this.autoPlayCarousel = false
            if (options.replay) {
                setTimeout(() => {
                    this.autoPlayCarousel = true
                }, options.replay);
            }
        },
        keyMoveCarousel() {

            // setInterval(() => {
            //     this.carousel({next: true, isManual: true});
            // }, 100)

            window.onkeyup = (event) => {
                if (this.scrollPos === 3) {
                    if (event.keyCode === 39) {
                        this.carousel({next: true, isManual: true});
                    }else if (event.keyCode === 37) {
                        this.carousel({prev: true, isManual: true});
                    }
                }
            }
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/scripts.js